import { Button, Stack, Tooltip, Typography } from "@mui/material";
import { WhatsApp } from "@mui/icons-material";

interface InsightPatientsBatchBarProps {
  selectedCount: number;
  whatsAppTooltip: string;
  whatsAppDisabled: boolean;
  canSendBatch: boolean;
  onSendBatch: () => void;
  onClearSelection: () => void;
}

export function InsightPatientsBatchBar({
  selectedCount,
  whatsAppTooltip,
  whatsAppDisabled,
  canSendBatch,
  onSendBatch,
  onClearSelection,
}: InsightPatientsBatchBarProps) {
  if (selectedCount <= 0) return null;

  return (
    <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
      <Typography variant="body2">{selectedCount} selecionados</Typography>
      <Tooltip title={whatsAppTooltip}>
        <span>
          <Button
            size="small"
            color="success"
            variant="contained"
            startIcon={<WhatsApp />}
            disabled={whatsAppDisabled || !canSendBatch}
            onClick={onSendBatch}
          >
            Enviar WhatsApp ({selectedCount})
          </Button>
        </span>
      </Tooltip>
      <Button size="small" onClick={onClearSelection}>
        Limpar seleção
      </Button>
    </Stack>
  );
}
